var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Chỉnh sửa khoản thu học sinh",
        size: "lg",
        "use-panel": false,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "danger", plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        disabled: _vm.loadingData,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Lưu")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingData,
              expression: "loadingData",
            },
          ],
          ref: "dataForm",
          staticClass: "sk-dialog-content",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-width": "170px",
            "label-position": "left",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-panel mb-4" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Thông tin học sinh & Phiếu thu"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Chi tiết thông tin phiếu thu (không thể chỉnh sửa)"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-2",
                          attrs: { label: "Họ tên", "label-width": "70px" },
                        },
                        [
                          _c("div", { staticClass: "cmd-readonly" }, [
                            _vm._v(_vm._s(_vm.dataForm.fullName || "-")),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label: "Tháng - Năm",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c("div", { staticClass: "cmd-readonly" }, [
                            _vm.dataForm.month && _vm.dataForm.year
                              ? _c("span", [
                                  _vm._v(
                                    "Tháng " +
                                      _vm._s(_vm.dataForm.month) +
                                      "/" +
                                      _vm._s(_vm.dataForm.year)
                                  ),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-0",
                          attrs: { label: "Đợt thu", "label-width": "70px" },
                        },
                        [
                          _c("div", { staticClass: "cmd-readonly" }, [
                            _vm.dataForm.turn
                              ? _c("span", [
                                  _vm._v("Đợt " + _vm._s(_vm.dataForm.turn)),
                                ])
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Mã khoản thu",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c("div", { staticClass: "cmd-readonly" }, [
                            _vm._v(_vm._s(_vm.dataForm.revenueCode || "-")),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sk-panel mb-4" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--success" },
                  [_c("i", { staticClass: "el-icon-edit-outline" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Chỉnh sửa chi tiết khoản thu chính"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Chỉnh sửa tên khoản thu, đơn giá, số lượng, giảm giá và mô tả"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tên khoản thu",
                            prop: "revenueName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: "Nhập tên khoản thu",
                            },
                            model: {
                              value: _vm.dataForm.revenueName,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "revenueName", $$v)
                              },
                              expression: "dataForm.revenueName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn vị tính", prop: "unit" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Chọn hoặc nhập đơn vị",
                              },
                              model: {
                                value: _vm.dataForm.unit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "unit", $$v)
                                },
                                expression: "dataForm.unit",
                              },
                            },
                            _vm._l(_vm.unitsList, function (u) {
                              return _c("el-option", {
                                key: u,
                                attrs: { label: u, value: u },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Đơn giá (VNĐ)", prop: "price" } },
                        [
                          _c("el-currency-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.currencyOptions,
                              disabled: _vm.isParentReadOnly,
                            },
                            model: {
                              value: _vm.dataForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "price", $$v)
                              },
                              expression: "dataForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Số lượng", prop: "quantity" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "number",
                              step: _vm.allowDecimal ? 0.01 : 1,
                              disabled: _vm.isParentReadOnly,
                            },
                            model: {
                              value: _vm.dataForm.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "quantity", _vm._n($$v))
                              },
                              expression: "dataForm.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Cho phép số thập phân" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              value: _vm.allowDecimal,
                              "active-text": "Có",
                              "inactive-text": "Không",
                            },
                            on: { change: _vm.handleAllowDecimalChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Giảm giá", prop: "discount" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleDiscountToggle },
                              model: {
                                value: _vm.dataForm.discount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "discount", $$v)
                                },
                                expression: "dataForm.discount",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("Có"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("Không"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Thành tiền (VNĐ)", prop: "amount" },
                        },
                        [
                          _c("el-currency-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.currencyOptions,
                              disabled: "",
                            },
                            model: {
                              value: _vm.displayAmount,
                              callback: function ($$v) {
                                _vm.displayAmount = $$v
                              },
                              expression: "displayAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Thuế suất", prop: "taxPercentage" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "Chọn thuế suất",
                                clearable: "",
                              },
                              on: { change: _vm.handleTaxChange },
                              model: {
                                value: _vm.dataForm.taxPercentage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dataForm, "taxPercentage", $$v)
                                },
                                expression: "dataForm.taxPercentage",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Không chịu thuế", value: -2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Không kê khai", value: -1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "0%", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "5%", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "8%", value: 8 },
                              }),
                              _c("el-option", {
                                attrs: { label: "10%", value: 10 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Khác", value: "other" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  String(_vm.dataForm.taxPercentage) === "other"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Thuế khác (%)",
                                prop: "taxPercentageInput",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  controls: false,
                                  min: 0,
                                  max: 100,
                                  placeholder: "Nhập % thuế",
                                },
                                model: {
                                  value: _vm.dataForm.taxPercentageInput,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataForm,
                                      "taxPercentageInput",
                                      $$v
                                    )
                                  },
                                  expression: "dataForm.taxPercentageInput",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.discount
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Loại giảm giá",
                                prop: "discountType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "Chọn loại giảm giá" },
                                  on: { change: _vm.handleDiscountTypeChange },
                                  model: {
                                    value: _vm.dataForm.discountType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "discountType",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.discountType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Phần trăm (%)",
                                      value: "PERCENT",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Số tiền (VNĐ)",
                                      value: "MONEY",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataForm.discount
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "discountValue" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm.dataForm.discountType === "PERCENT"
                                          ? _c("span", [
                                              _vm._v("Phần trăm giảm (%)"),
                                            ])
                                          : _c("span", [
                                              _vm._v("Số tiền giảm (VNĐ)"),
                                            ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                568855960
                              ),
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-discount-container" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "edit-discount-input" },
                                    [
                                      _vm.dataForm.discountType === "MONEY"
                                        ? [
                                            _c("el-currency-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                options: _vm.currencyOptions,
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountValue,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountValue",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("el-input-number", {
                                              directives: [
                                                {
                                                  name: "discount-percent",
                                                  rawName: "v-discount-percent",
                                                },
                                              ],
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                min: 0,
                                                max: 100,
                                                precision: 0,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value:
                                                  _vm.dataForm.discountValue,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataForm,
                                                    "discountValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataForm.discountValue",
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm.discountAmount > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "erd-discount-amount" },
                                        [
                                          _vm._v(
                                            "\n                -" +
                                              _vm._s(
                                                _vm.formatMoney(
                                                  _vm.discountAmount
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Mô tả", prop: "description" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "Nhập mô tả...",
                            },
                            model: {
                              value: _vm.dataForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "description", $$v)
                              },
                              expression: "dataForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.dataForm.calculationType === "FORMULA"
            ? _c(
                "div",
                { staticClass: "sk-panel mb-4 eid-formula-panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-s-operation" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Công thức tính"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Đơn giá khoản chính được tính tự động từ công thức dưới đây"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: "Biểu thức",
                                "label-width": "100px",
                              },
                            },
                            [
                              _c("div", { staticClass: "eid-formula-expr" }, [
                                _vm._v(_vm._s(_vm.dataForm.formulaExpression)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.formulaExpressionName
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    label: "Diễn giải",
                                    "label-width": "100px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "eid-formula-name" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dataForm.formulaExpressionName
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.calculationType === "SUM_BLOCKS"
            ? _c("div", { staticClass: "sk-panel mb-4 eid-formula-panel" }, [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c(
                    "div",
                    { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                    [_c("i", { staticClass: "el-icon-time" })]
                  ),
                  _c("div", [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v("Tính theo khung giờ"),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v(
                        "Đơn giá và số lượng khoản chính được tổng hợp tự động từ các khung giờ bên dưới"
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.dataForm.invoiceDetailItems &&
          _vm.dataForm.invoiceDetailItems.length > 0
            ? [
                _c(
                  "el-collapse",
                  {
                    staticClass: "mb-4 sk-child-collapse",
                    model: {
                      value: _vm.activeChildPanels,
                      callback: function ($$v) {
                        _vm.activeChildPanels = $$v
                      },
                      expression: "activeChildPanels",
                    },
                  },
                  _vm._l(
                    _vm.dataForm.invoiceDetailItems,
                    function (child, index) {
                      return _c(
                        "el-collapse-item",
                        {
                          key: child.idx || index,
                          staticClass: "sk-panel",
                          attrs: { name: child.idx || String(index) },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              { staticClass: "sk-panel-head child-panel-head" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "sk-panel-icon sk-panel-icon--success",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-edit-outline",
                                    }),
                                  ]
                                ),
                                _c("div", [
                                  _c("p", { staticClass: "sk-panel-title" }, [
                                    child.alias
                                      ? _c(
                                          "span",
                                          { staticClass: "eid-alias-badge" },
                                          [_vm._v(_vm._s(child.alias))]
                                        )
                                      : _vm._e(),
                                    _vm.dataForm.calculationType ===
                                    "SUM_BLOCKS"
                                      ? _c("span", [
                                          _vm._v(_vm._s(child.revenueName)),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "Khoản phụ: " +
                                              _vm._s(child.revenueName)
                                          ),
                                        ]),
                                  ]),
                                  _c(
                                    "p",
                                    { staticClass: "sk-panel-subtitle" },
                                    [
                                      _vm._v(
                                        "Thành tiền: " +
                                          _vm._s(
                                            _vm.formatMoney(
                                              _vm.getCalculatedAmount(child)
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "child-panel-body" },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Tên khoản thu",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".revenueName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { disabled: "" },
                                            model: {
                                              value: child.revenueName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  child,
                                                  "revenueName",
                                                  $$v
                                                )
                                              },
                                              expression: "child.revenueName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Đơn vị tính",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".unit",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                "allow-create": "",
                                                "default-first-option": "",
                                                placeholder:
                                                  "Chọn hoặc nhập đơn vị",
                                              },
                                              on: {
                                                change: (val) =>
                                                  _vm.handleChildUnitChange(
                                                    val
                                                  ),
                                              },
                                              model: {
                                                value: child.unit,
                                                callback: function ($$v) {
                                                  _vm.$set(child, "unit", $$v)
                                                },
                                                expression: "child.unit",
                                              },
                                            },
                                            _vm._l(_vm.unitsList, function (u) {
                                              return _c("el-option", {
                                                key: u,
                                                attrs: { label: u, value: u },
                                              })
                                            }),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Đơn giá (VNĐ)",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".price",
                                            rules: [
                                              {
                                                validator:
                                                  _vm.validateChildPrice,
                                                trigger: "blur",
                                              },
                                            ],
                                          },
                                        },
                                        [
                                          _c("el-currency-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              options: _vm.currencyOptions,
                                            },
                                            model: {
                                              value: child.price,
                                              callback: function ($$v) {
                                                _vm.$set(child, "price", $$v)
                                              },
                                              expression: "child.price",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Số lượng",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".quantity",
                                            rules: _vm.childQuantityRules,
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "number",
                                              step: _vm.allowDecimal ? 0.01 : 1,
                                            },
                                            model: {
                                              value: child.quantity,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  child,
                                                  "quantity",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "child.quantity",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Giảm giá",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".discount",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.dataForm
                                                    .calculationType ===
                                                  "SUM_BLOCKS",
                                              },
                                              on: {
                                                change: (val) =>
                                                  _vm.handleChildDiscountToggle(
                                                    val,
                                                    child
                                                  ),
                                              },
                                              model: {
                                                value: child.discount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    child,
                                                    "discount",
                                                    $$v
                                                  )
                                                },
                                                expression: "child.discount",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: true } },
                                                [_vm._v("Có")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: false } },
                                                [_vm._v("Không")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Thành tiền (VNĐ)",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".amount",
                                          },
                                        },
                                        [
                                          _c("el-currency-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              value:
                                                _vm.getCalculatedAmount(child),
                                              options: _vm.currencyOptions,
                                              disabled: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  child.discount
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Loại giảm giá",
                                                prop:
                                                  "invoiceDetailItems." +
                                                  index +
                                                  ".discountType",
                                                rules: [
                                                  {
                                                    validator: (r, v, c) =>
                                                      _vm.validateChildDiscountType(
                                                        r,
                                                        v,
                                                        c,
                                                        child
                                                      ),
                                                    trigger: "change",
                                                  },
                                                ],
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder:
                                                      "Chọn loại giảm giá",
                                                  },
                                                  on: {
                                                    change: () =>
                                                      _vm.handleChildDiscountTypeChange(
                                                        child
                                                      ),
                                                  },
                                                  model: {
                                                    value: child.discountType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        child,
                                                        "discountType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "child.discountType",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "Phần trăm (%)",
                                                      value: "PERCENT",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "Số tiền (VNĐ)",
                                                      value: "MONEY",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  child.discount
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "invoiceDetailItems." +
                                                  index +
                                                  ".discountValue",
                                                rules: [
                                                  {
                                                    validator: (r, v, c) =>
                                                      _vm.validateChildDiscountValue(
                                                        r,
                                                        v,
                                                        c,
                                                        child
                                                      ),
                                                    trigger: "blur",
                                                  },
                                                ],
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        child.discountType ===
                                                        "PERCENT"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "Phần trăm giảm (%)"
                                                              ),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                "Số tiền giảm (VNĐ)"
                                                              ),
                                                            ]),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "edit-discount-container",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "edit-discount-input",
                                                    },
                                                    [
                                                      child.discountType ===
                                                      "MONEY"
                                                        ? [
                                                            _c(
                                                              "el-currency-input",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  options:
                                                                    _vm.currencyOptions,
                                                                },
                                                                model: {
                                                                  value:
                                                                    child.discountValue,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        child,
                                                                        "discountValue",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "child.discountValue",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        : [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "discount-percent",
                                                                    rawName:
                                                                      "v-discount-percent",
                                                                  },
                                                                ],
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 100,
                                                                  precision: 0,
                                                                  "controls-position":
                                                                    "right",
                                                                },
                                                                model: {
                                                                  value:
                                                                    child.discountValue,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        child,
                                                                        "discountValue",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "child.discountValue",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                  _vm.getDiscountAmount(child) >
                                                  0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "erd-discount-amount",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      -" +
                                                              _vm._s(
                                                                _vm.formatMoney(
                                                                  _vm.getDiscountAmount(
                                                                    child
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Mô tả",
                                            prop:
                                              "invoiceDetailItems." +
                                              index +
                                              ".description",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: 2,
                                              placeholder: "Nhập mô tả...",
                                            },
                                            model: {
                                              value: child.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  child,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "child.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    }
                  ),
                  1
                ),
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "sk-panel" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c(
                  "div",
                  { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                  [_c("i", { staticClass: "el-icon-tickets" })]
                ),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Hóa đơn điện tử"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v("Cấu hình xuất hóa đơn điện tử cho khoản thu này"),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Xuất hóa đơn điện tử",
                    prop: "issuingElectronicInvoices",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.issuingElectronicInvoices,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.dataForm,
                            "issuingElectronicInvoices",
                            $$v
                          )
                        },
                        expression: "dataForm.issuingElectronicInvoices",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Có"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Không"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }